import { SupportedExpansionLocale } from ".";

const euroPriceScale: [PriceMap, PriceMap, PriceMap, PriceMap, PriceMap, PriceMap] = [
    // prettier-ignore
    {light: { b: 99 + 10 * 0, u: 49 }, pro: { b: 149 + 10 * 0, u: 49 }, commercial: { b: 119 + 10 * 3, u: 59 }},
    // prettier-ignore
    {light: { b: 99 + 10 * 2, u: 49 }, pro: { b: 149 + 10 * 3, u: 49 }, commercial: { b: 119 + 10 * 6, u: 69 }},
    // prettier-ignore
    {light: { b: 99 + 10 * 4, u: 59 }, pro: { b: 149 + 10 * 6, u: 59 }, commercial: { b: 119 + 10 * 9, u: 69 }},
    // prettier-ignore
    {light: { b: 99 + 10 * 6, u: 69 }, pro: { b: 149 + 10 * 9, u: 69 }, commercial: { b: 119 + 10 * 12, u: 79 }},
    // prettier-ignore 179,90,69 / 269,69 / 259, 130, 89
    { light: { b: 99 + 10 * 8, u: 69 }, pro: { b: 149 + 10 * 12, u: 69 }, commercial: { b: 119 + 10 * 14, u: 89 } },
    // prettier-ignore 199, 99, 69 / 299, 69 / 299, 149, 99
    { light: { b: 99 + 10 * 10, u: 69 }, pro: { b: 149 + 10 * 15, u: 69 }, commercial: { b: 119 + 10 * 18, u: 99 } },
];

export const PRICING = {
    // not relevant for now, only for reference page
    "EN-GB": euroPriceScale,
    "CZ-CZ": euroPriceScale,
    "EL-GR": [
        // Euro: 89/29 | 109/39 | 139/49 | 169/50 | 199/69
        { light: { b: 79 + 10 * 0, u: 29 }, pro: { b: 119 + 10 * 0, u: 29 }, commercial: { b: 139 + 10 * 0, u: 29 } },
        { light: { b: 79 + 10 * 3, u: 39 }, pro: { b: 119 + 10 * 3, u: 39 }, commercial: { b: 139 + 10 * 3, u: 39 } },
        { light: { b: 79 + 10 * 6, u: 49 }, pro: { b: 119 + 10 * 6, u: 49 }, commercial: { b: 139 + 10 * 6, u: 49 } },
        { light: { b: 79 + 10 * 9, u: 59 }, pro: { b: 119 + 10 * 9, u: 59 }, commercial: { b: 139 + 10 * 9, u: 59 } },
        {
            light: { b: 79 + 10 * 12, u: 69 },
            pro: { b: 119 + 10 * 12, u: 69 },
            commercial: { b: 139 + 10 * 12, u: 69 },
        },
        {
            light: { b: 99 + 10 * 11, u: 69 },
            pro: { b: 189 + 10 * 11, u: 69 },
            commercial: { b: 119 + 10 * 11, u: 129 },
        },
    ],
    "TR-TR": [
        // Turkey, in USD
        { light: { b: 89, u: 29 }, pro: { b: 89, u: 29 }, commercial: { b: 89, u: 29 } },
        { light: { b: 109, u: 39 }, pro: { b: 109, u: 39 }, commercial: { b: 109, u: 39 } },
        { light: { b: 129, u: 49 }, pro: { b: 129, u: 49 }, commercial: { b: 129, u: 49 } },
        { light: { b: 149, u: 59 }, pro: { b: 149, u: 59 }, commercial: { b: 149, u: 59 } },
        { light: { b: 169, u: 69 }, pro: { b: 169, u: 69 }, commercial: { b: 169, u: 69 } },
        { light: { b: 169, u: 69 }, pro: { b: 169, u: 69 }, commercial: { b: 169, u: 69 } },
    ],
    "ES-MX": [
        // Mexican Peso | 85/28 | 95/28 | 113/37 | 132/37 | 151/47
        // prettier-ignore
        {light: { b: 1800 + 200 * 1, u: 800 }, pro: { b: 2400 + 200 * 2, u: 800 }, commercial: { b: 2600 + 200 * 0, u: 1000 }},
        // prettier-ignore
        {light: { b: 1800 + 200 * 2, u: 800 }, pro: { b: 2400 + 200 * 3, u: 800 }, commercial: { b: 2600 + 200 * 2, u: 1200 }},
        // prettier-ignore
        {light: { b: 1800 + 200 * 4, u: 1000 }, pro: { b: 2400 + 200 * 6, u: 1000 }, commercial: { b: 2600 + 200 * 4, u: 1400 }},
        // prettier-ignore
        {light: { b: 1800 + 200 * 6, u: 1200 }, pro: { b: 2400 + 200 * 9, u: 1200 }, commercial: { b: 2600 + 200 * 6, u: 1600 }},
        // prettier-ignore
        {light: { b: 1800 + 200 * 10, u: 1400 }, pro: { b: 2400 + 200 * 15, u: 1400 }, commercial: { b: 2600 + 200 * 10, u: 2000 }},
        // 4200, 199 + 99 + 69
        // 6200, 299 + 69
        // 280 + 140 + 130
        {
            light: { b: 1800 + 200 * 12, u: 1499 },
            pro: { b: 1800 + 200 * 22, u: 1499 },
            commercial: { b: 2600 + 200 * 17, u: 2799 },
        },
    ],
    // "NL-NL": euroPriceScale,
    // "FR-BE": euroPriceScale,
    // "NL-BE": euroPriceScale,
    "ET-EE": euroPriceScale,
    "LV-LV": euroPriceScale,
    "LT-LT": euroPriceScale,
    "FR-CA": [
        { light: { b: 119, u: 59 }, pro: { b: 169, u: 79 }, commercial: { b: 119, u: 90 } },
        { light: { b: 129, u: 79 }, pro: { b: 199, u: 89 }, commercial: { b: 220, u: 110 } },
        { light: { b: 169, u: 89 }, pro: { b: 229, u: 99 }, commercial: { b: 270, u: 130 } },
        { light: { b: 189, u: 109 }, pro: { b: 249, u: 119 }, commercial: { b: 320, u: 140 } },
        { light: { b: 219, u: 119 }, pro: { b: 299, u: 129 }, commercial: { b: 370, u: 140 } },
        { light: { b: 249, u: 129 }, pro: { b: 399, u: 139 }, commercial: { b: 410, u: 140 } },
    ],
    "EN-CA": [
        { light: { b: 119, u: 59 }, pro: { b: 169, u: 79 }, commercial: { b: 119, u: 90 } },
        { light: { b: 129, u: 79 }, pro: { b: 199, u: 89 }, commercial: { b: 220, u: 110 } },
        { light: { b: 169, u: 89 }, pro: { b: 229, u: 99 }, commercial: { b: 270, u: 130 } },
        { light: { b: 189, u: 109 }, pro: { b: 249, u: 119 }, commercial: { b: 320, u: 140 } },
        { light: { b: 219, u: 119 }, pro: { b: 299, u: 129 }, commercial: { b: 370, u: 140 } },
        { light: { b: 249, u: 129 }, pro: { b: 399, u: 139 }, commercial: { b: 410, u: 140 } },
    ],  
} satisfies Record<SupportedExpansionLocale | "EN-GB", [PriceMap, PriceMap, PriceMap, PriceMap, PriceMap, PriceMap]>;

export const OnboardingFee = {
    "EN-GB": [0, 99, 199, 299, 499, 599],
    "ES-MX": [0, 1800, 3600, 5400, 7200, 9000],
    // euro default
    // "NL-NL": [0, 99, 199, 299, 499, 599],
    // euro default
    "CZ-CZ": [0, 99, 199, 299, 499, 599],
    // euro default
    "EL-GR": [0, 99, 199, 299, 499, 599],
    // euro default
    "ET-EE": [0, 99, 199, 299, 499, 599],
    // euro default
    // "FR-BE": [0, 99, 199, 299, 499, 599],
    // euro default
    "LT-LT": [0, 99, 199, 299, 499, 599],
    // euro default
    "LV-LV": [0, 99, 199, 299, 499, 599],
    // euro default
    // "NL-BE": [0, 99, 199, 299, 499, 599],
    // dollars default
    "TR-TR": [0, 99, 199, 299, 499, 599],
    // dollars default
    "FR-CA": [0, 99, 199, 299, 499, 599],
    // dollars default
    "EN-CA": [0, 99, 199, 299, 499, 599],
} satisfies Record<SupportedExpansionLocale | "EN-GB", [number, number, number, number, number, number]>;

type PriceMap = {
    light: PriceVariants;
    pro: PriceVariants;
    commercial: PriceVariants;
};

type PriceVariants = {
    b: number;
    u: number;
};
